export default __webpack_public_path__ + "static/media/top.cc6bf031.png";